var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quantity-fixed"},[_c('div',{staticClass:"number"},[_vm._v("x"+_vm._s(_vm.amount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }